export default {"src":"https://images-cdn.curipod.com/d-932c92f6/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};